import { render, staticRenderFns } from "./checkout-como-points.vue?vue&type=template&id=2fbc69f4"
import script from "./checkout-como-points.vue?vue&type=script&lang=ts"
export * from "./checkout-como-points.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbc69f4')) {
      api.createRecord('2fbc69f4', component.options)
    } else {
      api.reload('2fbc69f4', component.options)
    }
    module.hot.accept("./checkout-como-points.vue?vue&type=template&id=2fbc69f4", function () {
      api.rerender('2fbc69f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/checkout-como-points.vue"
export default component.exports